module.exports = __webpack_public_path__ + "static/media/5.55feef4d.jpg";